module.exports = __webpack_public_path__ + "static/media/thumbnail_rumi-ii-tips@3x.fbb738ef.jpg";